var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddtocartPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 208,
    viewBox: "0 0 255 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.449 134.453C226.596 135.385 231.81 135.275 231.81 135.275C231.81 135.275 230.682 131.828 230.584 131.594C229.43 129.141 225.787 125.202 222.817 125.607C222.326 125.688 221.858 125.87 221.442 126.143C221.026 126.417 220.673 126.774 220.404 127.193C220.136 127.612 219.958 128.083 219.884 128.575C219.809 129.067 219.839 129.569 219.971 130.049C220.548 132.122 222.621 133.656 224.449 134.453Z",
    fill: "#F0AE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.8133 0C-28.8133 0 -13.3301 5.34916 -10.9868 13.4956C-8.64348 21.642 2.96274 66.4597 6.07899 73.0971C9.19525 79.7344 16.2252 83.6236 16.2252 88.7029C16.2252 93.7821 16.6055 97.6713 16.6055 97.6713C16.6055 97.6713 24.8011 98.0639 25.5863 104.689C26.3715 111.314 27.9173 119.902 27.9173 119.902L59.1412 168.192C59.1412 168.192 77.7529 169.689 82.0469 169.308C86.341 168.928 99.0882 169.726 103.75 172.179C105.554 173.136 109.149 176.228 111.97 186.166C113.369 191.073 116.473 200.655 114.522 200.262C112.572 199.87 110.167 194.447 109.394 193.269C108.228 190.719 107.204 188.106 106.327 185.442C106.327 185.442 107.885 196.754 108.277 199.097C108.457 200.696 108.189 202.314 107.505 203.771L107.333 203.845C105.414 204.623 103.293 204.748 101.297 204.201L99.7016 203.771C98.1978 204.584 96.4339 204.769 94.7941 204.287L93.052 203.771C93.052 203.771 90.5247 195.76 88.1445 192.644C85.7644 189.527 78.4522 186.129 78.4522 186.129C78.4522 186.129 86.3901 195.195 85.9975 201.048C85.838 203.415 86.3901 205.329 84.4393 204.164C82.4886 202.998 80.1453 197.146 75.8512 195.195C71.5572 193.245 61.4232 190.509 57.5218 188.165C53.6203 185.822 47.3755 177.246 47.3755 177.246L-3.67466 131.275C-3.67466 131.275 -8.74163 126.208 -9.52683 123.472L-10.2998 120.749C-10.2998 120.749 -17.3298 116.455 -19.2805 114.111C-21.2312 111.768 -22.0041 106.75 -22.0041 106.75L-32.543 94.6655L-25.513 27.9604",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-28.8133 0C-28.8133 0 -13.3301 5.34916 -10.9868 13.4956C-8.64348 21.642 2.96274 66.4597 6.07899 73.0971C9.19525 79.7344 16.2252 83.6236 16.2252 88.7029C16.2252 93.7821 16.6055 97.6713 16.6055 97.6713C16.6055 97.6713 24.8011 98.0639 25.5863 104.689C26.3715 111.314 27.9173 119.902 27.9173 119.902L59.1412 168.192C59.1412 168.192 77.7529 169.689 82.0469 169.308C86.341 168.928 99.0882 169.726 103.75 172.179C105.554 173.136 109.149 176.228 111.97 186.166C113.369 191.073 116.473 200.655 114.522 200.262C112.572 199.87 110.167 194.447 109.394 193.269C108.228 190.719 107.204 188.106 106.327 185.442C106.327 185.442 107.885 196.754 108.277 199.097C108.457 200.696 108.189 202.314 107.505 203.771L107.333 203.845C105.414 204.623 103.293 204.748 101.297 204.201L99.7016 203.771C98.1978 204.584 96.4339 204.769 94.7941 204.287L93.052 203.771C93.052 203.771 90.5246 195.76 88.1445 192.644C85.7644 189.527 78.4522 186.129 78.4522 186.129C78.4522 186.129 86.3901 195.195 85.9975 201.048C85.838 203.415 86.3901 205.329 84.4393 204.164C82.4886 202.998 80.1453 197.146 75.8512 195.195C71.5572 193.245 61.4232 190.509 57.5218 188.165C53.6203 185.822 47.3755 177.246 47.3755 177.246L-3.67466 131.275C-3.67466 131.275 -8.74163 126.208 -9.52683 123.472L-10.2998 120.749C-10.2998 120.749 -17.3298 116.455 -19.2805 114.111C-21.2312 111.768 -22.0041 106.75 -22.0041 106.75L-32.543 94.6655L-25.513 27.9604",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-29.5003 43.37L-32.543 94.6287L-22.0041 106.738C-22.0041 106.738 -21.2312 111.817 -19.2805 114.099C-17.3298 116.381 -10.2998 120.737 -10.2998 120.737L-9.52682 123.46C-8.74163 126.196 -3.67466 131.263 -3.67466 131.263L3.96877 138.158C7.08503 132.097 14.4708 121.166 27.8192 119.411C27.4757 117.448 26.2488 110.394 25.5863 104.689C24.8011 98.0639 16.6055 97.6713 16.6055 97.6713C16.6055 97.6713 16.2252 93.7699 16.2252 88.7029C16.2252 83.6359 9.19525 79.7222 6.079 73.0971C2.96274 66.4719 -8.64348 21.6911 -10.9868 13.4956C-13.3301 5.30009 -28.8133 0 -28.8133 0",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-29.5003 43.37L-32.543 94.6287L-22.0041 106.738C-22.0041 106.738 -21.2312 111.817 -19.2805 114.099C-17.3298 116.381 -10.2998 120.737 -10.2998 120.737L-9.52683 123.46C-8.74163 126.196 -3.67466 131.263 -3.67466 131.263L3.96877 138.158C7.08503 132.097 14.4708 121.166 27.8192 119.411C27.4757 117.448 26.2488 110.394 25.5863 104.689C24.8011 98.0639 16.6055 97.6713 16.6055 97.6713C16.6055 97.6713 16.2252 93.7699 16.2252 88.7029C16.2252 83.6359 9.19525 79.7222 6.079 73.0971C2.96274 66.4719 -8.64348 21.6911 -10.9868 13.4956C-13.3301 5.30009 -28.8133 0 -28.8133 0",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.11328 104.615C7.19293 103.867 8.34617 103.131 9.58531 102.419",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16406 97.6959C3.86284 97.4188 5.58412 97.3038 7.30466 97.3524",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5837 189.024C80.5837 189.024 76.2897 183.171 70.4375 182.779",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5352 176.153C82.5352 176.153 87.2096 177.318 93.0617 184.741C98.9139 192.164 100.423 203.083 100.423 203.083",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7012 174.596C93.7012 174.596 102.424 181.613 103.982 188.239C105.54 194.864 107.503 203.844 107.503 203.844",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.325 185.515C105.254 181.052 103.406 176.812 100.865 172.989",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M224.521 201.097H116.863L146.505 102.8H254.163L224.521 201.097Z",
    fill: "#E1E1E1",
    stroke: "black",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.802 155.456C194.504 155.456 198.316 151.787 198.316 147.261C198.316 142.735 194.504 139.065 189.802 139.065C185.099 139.065 181.287 142.735 181.287 147.261C181.287 151.787 185.099 155.456 189.802 155.456Z",
    fill: "#0D5EFB",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M225.687 200.704H24.4062V206.949H225.687V200.704Z",
    fill: "white",
    stroke: "#0A297A",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M225.698 200.704H115.148V206.949H225.698V200.704Z",
    fill: "#0D5EFB",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.713 200.704L123.105 201.097H124.026C123.576 201.012 123.136 200.88 122.713 200.704Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.22687,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtocartPic);
export default __webpack_public_path__ + "static/media/addtocartPic.7ddc59e3fa9ea5eef70bd1eae2710aa4.svg";
export { ForwardRef as ReactComponent };